module.exports = __webpack_public_path__ + "ce282152656cf15483d18b64f4d707d6.png";